import { render } from "./goToNewsButton.vue?vue&type=template&id=1de9ef36&scoped=true"
import script from "./goToNewsButton.vue?vue&type=script&lang=js"
export * from "./goToNewsButton.vue?vue&type=script&lang=js"

import "./goToNewsButton.vue?vue&type=style&index=0&id=1de9ef36&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de9ef36"]])

export default __exports__